var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 0.742851C11.9368 0.742851 8.63071 4.04892 8.63071 8.11259C8.63071 12.1763 11.9368 15.4823 16.0005 15.4823C20.0641 15.4823 23.3702 12.1763 23.3702 8.11259C23.3702 4.04892 20.0641 0.742851 16.0005 0.742851ZM18.6536 12.2396H13.9369V10.4709H15.4109V5.75427H13.9369V3.98554H17.1796V10.4709H18.6536V12.2396Z",
    fill: "url(#paint0_linear_383_330)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9365 21.027C17.0883 20.8285 17.1796 20.5814 17.1796 20.3128C17.1796 19.6626 16.6506 19.1337 16.0005 19.1337C15.3503 19.1337 14.8213 19.6626 14.8213 20.3128C14.8213 20.5814 14.9126 20.8285 15.0644 21.027C14.7166 23.4531 12.6255 25.3242 10.1047 25.3242V27.093C12.6276 27.093 14.8329 25.7076 16.0005 23.6578C17.168 25.7076 19.3733 27.093 21.8962 27.093V25.3242C19.3754 25.3243 17.2843 23.4531 16.9365 21.027Z",
    fill: "url(#paint1_linear_383_330)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.928 16.7746C17.9587 16.8859 16.927 18.2751 17.2418 19.8298C18.7952 19.8298 19.6169 18.3673 18.928 16.7746Z",
    fill: "url(#paint2_linear_383_330)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3028 20.4505C17.3028 22.0521 18.8025 23.2091 20.7826 22.4125C20.6892 21.6689 19.51 20.0254 17.3028 20.4505Z",
    fill: "url(#paint3_linear_383_330)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3302 15.5645C20.1929 16.1465 20.0259 17.9201 20.6127 18.9782C21.982 18.608 22.507 16.8835 21.3302 15.5645Z",
    fill: "url(#paint4_linear_383_330)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8533 19.5537C21.264 20.9221 22.8412 21.718 24.7557 20.4113C24.3642 19.5709 22.7724 18.5638 20.8533 19.5537Z",
    fill: "url(#paint5_linear_383_330)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2803 13.7006C22.13 14.8887 23.0328 16.7202 23.5882 17.1788C25.0005 16.2743 24.5903 14.5104 23.2803 13.7006Z",
    fill: "url(#paint6_linear_383_330)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9864 17.6588C24.7917 18.9782 26.8896 19.06 27.9666 17.3425C26.8208 16.2546 24.9931 16.6034 23.9864 17.6588Z",
    fill: "url(#paint7_linear_383_330)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5999 11.3549C24.0301 12.27 24.6295 14.0191 25.9083 14.5878C26.9191 13.2919 26.1281 11.7492 24.5999 11.3549Z",
    fill: "url(#paint8_linear_383_330)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4289 14.9314C27.4153 15.8173 29.4002 15.7092 30.1468 13.4664C28.5453 12.5943 26.7668 14.0682 26.4289 14.9314Z",
    fill: "url(#paint9_linear_383_330)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1716 8.72699C24.9735 9.41544 25.5483 11.0859 27.375 11.4355C28.0344 9.69549 26.4867 8.65394 25.1716 8.72699Z",
    fill: "url(#paint10_linear_383_330)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9734 11.6112C28.9728 12.1374 31.0947 11.5969 31.0937 9.11959C29.6312 8.84556 28.1916 10.0794 27.9734 11.6112Z",
    fill: "url(#paint11_linear_383_330)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9582 6.03698C25.1221 7.55585 26.9572 8.14909 27.8484 7.99002C27.9631 6.34586 26.5334 5.5218 24.9582 6.03698Z",
    fill: "url(#paint12_linear_383_330)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.739 4.69303C29.0833 4.8659 28.3058 6.67148 28.4721 7.98365C30.5007 8.19213 31.2328 6.13839 30.739 4.69303Z",
    fill: "url(#paint13_linear_383_330)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9666 3.53858C24.4035 4.58591 25.9733 5.1239 27.3039 4.55542C27.1819 3.57619 25.7817 2.24964 23.9666 3.53858Z",
    fill: "url(#paint14_linear_383_330)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0976 0.555542C27.3883 1.28426 27.4251 3.52466 27.8985 4.36717C29.9382 3.89521 29.9751 1.85904 29.0976 0.555542Z",
    fill: "url(#paint15_linear_383_330)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0729 16.7746C12.384 18.3673 13.2057 19.8298 14.7591 19.8298C15.0739 18.2751 14.0422 16.8859 13.0729 16.7746Z",
    fill: "url(#paint16_linear_383_330)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2183 22.4125C13.1984 23.2091 14.6981 22.0521 14.6981 20.4505C12.4909 20.0254 11.3117 21.6689 11.2183 22.4125Z",
    fill: "url(#paint17_linear_383_330)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6707 15.5645C9.49386 16.8835 10.0189 18.608 11.3882 18.9782C11.975 17.9201 11.808 16.1465 10.6707 15.5645Z",
    fill: "url(#paint18_linear_383_330)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2452 20.4113C9.15974 21.718 10.7369 20.9221 11.1476 19.5537C9.22855 18.5638 7.63668 19.5709 7.2452 20.4113Z",
    fill: "url(#paint19_linear_383_330)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72057 13.7006C7.41064 14.5104 7.00041 16.2743 8.41269 17.1788C8.96813 16.7202 9.87089 14.8887 8.72057 13.7006Z",
    fill: "url(#paint20_linear_383_330)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0343 17.3425C5.11134 19.06 7.20924 18.9782 8.01449 17.6588C7.00778 16.6034 5.18008 16.2546 4.0343 17.3425Z",
    fill: "url(#paint21_linear_383_330)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40097 11.3549C5.87284 11.7492 5.0818 13.2919 6.09258 14.5878C7.37137 14.0191 7.9708 12.27 7.40097 11.3549Z",
    fill: "url(#paint22_linear_383_330)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85415 13.4664C2.60068 15.7092 4.58561 15.8173 5.57198 14.9314C5.23415 14.0682 3.45556 12.5943 1.85415 13.4664Z",
    fill: "url(#paint23_linear_383_330)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82931 8.72699C5.5142 8.65394 3.96655 9.69549 4.62594 11.4355C6.45257 11.086 7.02741 9.41544 6.82931 8.72699Z",
    fill: "url(#paint24_linear_383_330)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.907227 9.11959C0.906225 11.5969 3.02812 12.1374 4.02746 11.6112C3.80931 10.0794 2.36974 8.84556 0.907227 9.11959Z",
    fill: "url(#paint25_linear_383_330)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15251 7.99002C5.04371 8.14909 6.87878 7.55585 7.04274 6.03698C5.4675 5.5218 4.03777 6.34586 4.15251 7.99002Z",
    fill: "url(#paint26_linear_383_330)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26186 4.69303C0.768086 6.13839 1.50017 8.19213 3.52879 7.98365C3.69511 6.67148 2.91757 4.8659 1.26186 4.69303Z",
    fill: "url(#paint27_linear_383_330)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69704 4.55542C6.0276 5.1239 7.59736 4.58591 8.0343 3.53858C6.21922 2.24964 4.81897 3.57619 4.69704 4.55542Z",
    fill: "url(#paint28_linear_383_330)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90331 0.555542C2.02584 1.85904 2.06268 3.89521 4.10239 4.36717C4.57577 3.5246 4.61261 1.2842 2.90331 0.555542Z",
    fill: "url(#paint29_linear_383_330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_383_330",
    x1: 16.0005,
    y1: 0.555542,
    x2: 16.0005,
    y2: 27.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA0067"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.2be2cdcc655fbba052c143594523276d.svg";
export { ForwardRef as ReactComponent };